module.exports = __webpack_public_path__ + "static/media/not-found.db4c31ce.png";